import React from 'react';
import PropTypes from 'prop-types';
import useClassNames from '@medflex/hooks/useClassNames';
import Tooltip from '../Tooltip';
import IconDoubleCheck from '../icons/DoubleCheck';

export const KIND = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
};

const KIND_COLORS = {
  [KIND.PRIMARY]: 'text-blue-600',
  [KIND.SECONDARY]: 'text-gray-600',
};

const MessageReadIndicator = ({ children, kind = KIND.SECONDARY }) => {
  const cn = useClassNames(() => [
    'flex justify-center focus:outline-none relative items-center',
    KIND_COLORS[kind],
  ]);

  return (
    <Tooltip title={children}>
      <button type="button" className={cn}>
        <IconDoubleCheck width="16px" height="8px" className="text-blur-600 fill-current" />
      </button>
    </Tooltip>
  );
};

MessageReadIndicator.defaultProps = {};

MessageReadIndicator.propTypes = {
  kind: PropTypes.oneOf(Object.values(KIND)),
  children: PropTypes.node.isRequired,
};

MessageReadIndicator.defaultProps = {
  kind: KIND.SECONDARY,
};

export default MessageReadIndicator;
